/* eslint-disable */
const getters = {
  getBrand(state) {
    return {
      ...state.data,
      photoable_type: 'App\\Brand',
    };
  },

  getBrandCategory(state) {
    return state.brandCategory;
  },

  getOrders(state) {
    return state.orders;
  },

  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
